import { useTypedQuery } from '../helpers/useTypedQuery';
import { useTypedSetCache } from '../helpers/useTypedSetCache';

export const usePressHeader = () => {
  const {
    isLoading: isLoadingPressHeader,
    data: pressHeader,
    refetch
  } = useTypedQuery('get', '/communication/press/header');

  return { isLoadingPressHeader, pressHeader, refetch };
};

export const usePressHeaderCacheUpdate = () =>
  useTypedSetCache('get', '/communication/press/header');
